import { css } from '@emotion/css';
import { theme } from 'core/theme';

export const root = css`
  display: block;
  width: 100%;
  height: 5px;
  background-image: ${theme.palette.gradients.g1('92deg')};
`;
